// extracted by mini-css-extract-plugin
module.exports = {"indiansLivingAbroadPage":"IndiansLivingAbroadPage_indiansLivingAbroadPage__oTm_s","certifiedInstructors":"IndiansLivingAbroadPage_certifiedInstructors___TrqH"};